import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { AuthRepository } from '../../domain/repository';
import { AuthForgotPasswordRequest, AuthForgotPasswordResponse } from '../../domain/dto';

@Injectable({ providedIn: 'root' })
export class ForgotPasswordUseCase {
  constructor(private authRepository: AuthRepository) {}

  execute(
    request: AuthForgotPasswordRequest,
  ): Observable<HttpResponse<AuthForgotPasswordResponse>> {
    return this.authRepository.forgotPassword(request);
  }
}


